// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__33iDv","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2qGYP"};